import React from 'react';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Grid, Tab } from '@mui/material';
import CommonTable from 'components/commonTable/CommonTable';
import CommonDateRangePicker from 'pages/date/CommonDateRangePicker';
import CommonFilter from 'components/commonFilter/CommonFilter';
import Loader from 'components/loader/Loader';
import SearchBar from 'components/commonSearch/SearchBar';

export default function RideTrackTab(props) {
  const handleChange = (event, newValue,) => {
    props?.handleChange(newValue)
  };

  const handleChangePage = (event, newPage) => {
    props?.handleChangePage(newPage)
  };
  const handleChangeRowsPerPage = (event) => {
    props?.handleChangeRowsPerPage(event)
  };
  

  const onClickTableVendor = (data) => {
    props?.onClickTableVendor(data)
  }
  
  const businessType = localStorage.getItem('businessType')

  return (
    <Grid container>

      <Grid item className="tableContainer" xs={12}>
        <Box className="contentBoxStyle">
          <TabContext value={props?.value}>
            <Grid
              container
              className="tabBoxStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <TabList
                className='minHeight32'
                  onChange={handleChange}
                  aria-label="lab API tabs example"
                >
                  {businessType ==='isB2C' && <Tab
                    label=" Ride"
                    value="1"
                    className="tabStyle"
                  /> }
                  <Tab label="Rental " value="2" className="tabStyle" />
                  <Tab label="Airport " value="3" className="tabStyle" />
                  {/* TODO need to add for Outstation */}
                  {businessType ==='isB2B' && <Tab label="Outstation " value="4" className="tabStyle" />}
                </TabList>
              </Grid>
              <Grid
                item
                container
                md={8}
                xs={12}
                spacing={4}
                direction="row"
                justifyContent="flex-end"
                alignItems="center"
              >
                <Grid item>
                  <SearchBar onSearch={props?.onSearch} search={props?.search}/>
                </Grid>
                <Grid item >
                  <div>
                  <CommonDateRangePicker onSelectDateRange={props?.onSelectDateRange} tabName={props?.tabName} dateFrom={props?.dateFrom} dateTo={props?.dateTo}/>
                  </div>
                </Grid>
                <Grid item className="filter_menu">
                  <CommonFilter filterdata={props?.filterData} onFilterChange={props?.onFilterChange} onRestFilter={props?.onRestFilter} defaultStatus={props.defaultStatus}/>
                </Grid>
              </Grid>
            </Grid>
            {props?.loader? 
              <Loader/> 
              :
              <TabPanel value={props?.value} className='vendotTable tabPanelStyle'>
                <CommonTable 
                  data={props?.rideTrackData} 
                  onClickTableVendor={onClickTableVendor}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  page={props?.page}
                  rowsPerPage={props?.rowsPerPage}
                  isClickable = {true}
                  tabName={props?.tabName}
                />
              </TabPanel>
            }
          </TabContext>
        </Box>
      </Grid>
    </Grid>
  );
}
